export default __webpack_public_path__ + "static/media/instagram-icon.617454b3.svg";